import React, { Component, Fragment } from 'react';
import { Switch, Link, NavLink, Redirect, Route } from 'react-router-dom';
import { translate } from 'react-i18next';
import Dropdown from './../../../../../copms/Dropdown/Dropdown';
import lastOperationsIcon from './../../../img/last-operations-icon.png';
import transferInternalIcon from './../../../img/transfer-internal-icon.svg';
import cardIcon from './../../../img/credit-cardcredit-card.svg';
import historyIcon from './../../../img/history.svg';
import qrIcon from './../../../img/qrcode.svg';
import friendTransferIcon from './../../../img/friend-transfer-icon.svg';
import zkTransferIcon from './../../../img/zk-transfer-icon.svg';
import fastMoneyIcon from './../../../img/fast-money-icon.svg';
import exchangeIcon from './../../../img/exchange_op.svg';
import { newRequest, request } from './../../../../../config';
import transferFilter from '../../../../../helpers/transferFilter';
import cardOperationFilter from '../../../../../helpers/cardOperationFilter';
import YesNoModal from '../../../../../copms/Modal/YesNoModal';
import Loading from '../../../Loading/Loading';
import currencyFilter from '../../../../../helpers/currencyFilter';
import { customerType } from '../../../../../helpers/customer';
import { statusCodes } from '../../../../../helpers/statusCodes';
import { Autocomplete, TextField } from '@mui/material';

class CreateAliasVisaPlus extends Component {
    state = {
        signLevel: null,
        signCount: null,
        open: false,
        modalCardObj: {},
        templates: [],
        statements: [],
        operations: [],
        cards: [],
        cardId: null,
        isCardToCard: false,
        mobile: '',
        step: 1
    }

    updateOpenModal = (value) => {
        this.setState({ open: value });
    }

    dropdownItemHandler = (index, tempIndex, url) => {
        switch (index) {
            case 1:
                this.setState({ deleteIndex: tempIndex, open: true })
                break;
        }
    }

    deleteCardTemplate(index) {
        this.props.updateAppState('isLoadingTransparentBackground', true);
        let customerType = localStorage.getItem('compId') === null ? 'Individual' : 'Juridical';
        let removePaymentTempCustomerRequestBody = customerType == 'Juridical' ? {
            compId: localStorage.getItem('compId'),
            custId: localStorage.getItem('custId'),
            token: localStorage.getItem('token'),
            tempId: this.state.templates[index].tempId,
            lang: localStorage.getItem('i18nextLng').toUpperCase()
        } : {
            custId: localStorage.getItem('custId'),
            token: localStorage.getItem('token'),
            tempId: this.state.templates[index].tempId,
            lang: localStorage.getItem('i18nextLng').toUpperCase()
        }

        fetch(request("card/deleteCreateTransferTemp", removePaymentTempCustomerRequestBody))
            .then(res => res.text())
            .then((removePaymentTempCustomerResponseJSON) => {
                const JSON = require('true-json-bigint');
                let removePaymentTempCustomerResponse = JSON.parse(removePaymentTempCustomerResponseJSON);
                if (removePaymentTempCustomerResponse.status.statusCode !== 1) {
                    if (removePaymentTempCustomerResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(removePaymentTempCustomerResponse.status.statusCode));
                        this.props.updateAppState('isLoadingTransparentBackground', false);
                    }
                }
                else {
                    var tempArr = this.state.templates;
                    tempArr.splice(index, 1);
                    this.setState({ templates: tempArr });
                    this.props.updateAppState('isLoadingTransparentBackground', false);
                }
            });
    }

    componentWillMount() {
        this.setState({ isLoading: true });
        if (localStorage.getItem('custObject')) {
            let custObject = JSON.parse(localStorage.getItem('custObject'));
            let mobile = (custObject.customer !== undefined) ? custObject.customer.mobile : custObject.mobile;
            if (mobile !== null && mobile !== undefined) {
                mobile = '+' + mobile.slice(0, 3) + ' (' + mobile.slice(3, 5) + ') ' + mobile.slice(5, 8) + '-' + mobile.slice(8, 10) + '-' + mobile.slice(10, 12);
            }
            this.setState({ mobile });
        }
        fetch(newRequest("visa/api/ads/aliases/check"))
            .then(res => res.text())
            .then((responseJSON) => {
                const JSON = require('true-json-bigint');
                let response = JSON.parse(responseJSON);
                if (response.status.statusCode !== 1 && response.status.statusCode !== 740) {
                    if (response.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(response.status.statusCode), null, true);
                    }
                }
                else {
                    if (response.status.statusCode === 740) {
                        this.setState({ open: true })
                    } else {
                        this.getVisaDirectCardList();
                    }
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    createAlias = () => {
        this.setState({ isLoading: true });
        let requestBody = {
            cardId: this.state.cardId,
        }
        fetch(newRequest("visa/api/ads/aliases", requestBody))
            .then(res => res.text())
            .then((responseJSON) => {
                const JSON = require('true-json-bigint');
                let response = JSON.parse(responseJSON);
                if (response.status.statusCode !== 1) {
                    if (response.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(response.status.statusCode));
                        this.setState({ isLoading: false });
                    }
                }
                else {
                    this.props.alertState(true, 'success', this.props.t('successful operation'), this.props.t(response.status.statusCode), null, null, () => this.props.history.push("/dashboard/transfer/visa-plus/settings"));
                }
            },
                (error) => {

                    this.props.history.push("/technical-break");
                });
    }

    getVisaDirectCardList = () => {
        let requestBody = {
            token: localStorage.getItem('token'),
            lang: localStorage.getItem('i18nextLng').toUpperCase(),
            custId: localStorage.getItem('custId')
        }
        fetch(request("card/getVisaDirectCardList", requestBody))
            .then(res => res.text())
            .then((responseJSON) => {
                const JSON = require('true-json-bigint');
                let response = JSON.parse(responseJSON);
                if (response.status.statusCode !== 1 && response.status.statusCode !== 137) {
                    if (response.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(response.status.statusCode));
                        this.setState({ isLoading: false });
                    }
                }
                else {
                    if (response.status.statusCode === 137) {
                        response.cardList = [];
                    }
                    this.setState({ cards: response.cardList, isLoading: false, open: false });
                }
            },
                (error) => {

                    this.props.history.push("/technical-break");
                });
    }

    // componentDidMount() {
    // }

    render() {
        let {  t } = this.props;
        let { open, isLoading, isCardToCard, cards, cardId, mobile } = this.state;
        return (
            <Fragment>
                <YesNoModal ok={t('Turanbank kartı əlavə et')} notOk={t('Mövcud kart ilə davam et')}
                    title={t("{{mobile}} nömrəniz hazırda Alias olaraq istifadə edilir və digər bank kartına bağlıdır. Ödənişləri Turanbank kartına qəbul etmək üçün kartı əlavə edərək onu əsas kart kimi təyin edə bilərsiniz.", { mobile })}
                    open={open} onClose={(val) => val ? this.getVisaDirectCardList() : this.props.history.push("/dashboard/transfer/visa-plus")} triggerFunc={() => this.getVisaDirectCardList()} />
                <div className="dashboard-header-route">
                    <div className="dashboard-header-route-left">
                        <button onClick={() => (this.props.history.goBack(), this.setState({ isCardToCard: !isCardToCard }))}>
                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.7344 21.2188L12.6719 20.3281C12.9062 20.0938 12.9062 19.7188 12.6719 19.5312L5.40625 12.2188H21.4375C21.7188 12.2188 22 11.9844 22 11.6562V10.3438C22 10.0625 21.7188 9.78125 21.4375 9.78125H5.40625L12.6719 2.51562C12.9062 2.32812 12.9062 1.95312 12.6719 1.71875L11.7344 0.828125C11.5469 0.59375 11.1719 0.59375 10.9375 0.828125L1.14062 10.625C0.90625 10.8594 0.90625 11.1875 1.14062 11.4219L10.9375 21.2188C11.1719 21.4531 11.5469 21.4531 11.7344 21.2188Z" fill="#2E3131" />
                            </svg>
                        </button>
                        <h2>{t('Visa+ money transfers')}</h2>
                    </div>
                </div>
                {isLoading ?
                    <div className="dashboard-container-main-section">
                        <Loading />
                    </div>
                    :
                    <div className="dashboard-container-main-section">
                        <div className="dashboard-account-container dashboard-container-main-section-home-left mw-100 bg-white">
                            <div className="dashboard-account-container-component">
                                <h3>{t('Yeni Alias')}</h3>
                                <Autocomplete
                                    sx={{ width: 320, '.MuiOutlinedInput-root': { background: 'white' }, '.MuiInputLabel-root': { color: '#1976d2' } }}
                                    options={cards || []}
                                    getOptionLabel={card => card.cardNumber + " / " + card.balance + " " + card.currency}
                                    // value={data?.accountList?.find(item => item.accountId == accountId) || null}
                                    onChange={(event, value) => this.setState({ cardId: value?.cardId })}
                                    disableClearable
                                    renderInput={(params) => <TextField label={t('Card')} {...params} />}
                                />
                                <TextField value={localStorage.getItem('fullname').split(' ')[1]} sx={{ width: 230 }} InputProps={{ readOnly: true }} label={t('name')} />
                                <TextField value={localStorage.getItem('fullname').split(' ')[0]} sx={{ width: 230 }} InputProps={{ readOnly: true }} label={t('surname')} />
                                <TextField value={mobile} sx={{ width: 230 }} InputProps={{ readOnly: true }} label={t('phone number')} />
                                <div className="dashboard-salary-order-container-box w-100">
                                    <button className="dashboard-salary-order-container-box-button dashboard-salary-order-container-box-button-main ml-auto" disabled={!cardId} onClick={() => this.createAlias()}>{t("continue")}</button>
                                    <button className="dashboard-salary-order-container-box-button dashboard-salary-order-container-box-button-outline" onClick={() => this.props.history.goBack()}>{t("Back")}</button>
                                </div>
                            </div>
                        </div>
                        <div className="dashboard-currency-convertor-calendar-section bg-white">

                            <div className="dashboard-finance-section-card-section-details-section-header">
                                <h3 className="dashboard-finance-section-card-section-details-section-header-title dashboard-last-operations-section-header-title">{t('How are money transfers made via Visa+?')}</h3>
                            </div>
                            <div className="dashboard-last-operations-section-content">
                                <img src={lastOperationsIcon} className="dashboard-last-operations-section-content-image w-75" alt="lastOperationsIcon" />
                                <p className="dashboard-last-operations-section-content-status">{t('visa+ text')}</p>
                            </div>

                        </div>
                    </div>
                }
            </Fragment>
        )
    }
}

export default translate("translation")(CreateAliasVisaPlus);